import React, { useMemo, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table } from 'antd';

import { getUserTeams } from '../users/state/users.actions';

import sortByString, { getIdMap } from '../helpers/helpers';
import TableFilterDropdown from '../common/tables/TableFilterDropdown';
import OntraccrTag from '../common/OntraccrTag';

export default ({
  divisions,
  onSelect,
  selected = [[],[]],
  data = [],
  scroll = {},
  additionalColumns = [],
  disableAll,
}) => {
  const dispatch = useDispatch();

  const positionNames = useSelector((state) => {
    const {
      settings:{
        positionNames = [],
      } = {},
    } = state;
    return positionNames;
  });

  const userTeams = useSelector(state => state.users.userTeams);
  const teams = useSelector(state => state.teams.teams);
  const company = useSelector(state => state.settings.company);
  const userDivisions = useSelector(state => state.users.userDivisions);

  const ourUsers = useMemo(() => (
    divisions ? data.filter((user) => {
      const {
        [user.id]: usersDivs = [],
      } = userDivisions;
      return divisions.some((divisionId) =>  usersDivs.includes(divisionId));
    }) : data
  ),[divisions, data, userDivisions])
  const activeTeams = useMemo(() => teams.filter(team => team.active),[teams]);
  const teamMap = useMemo(() => getIdMap(activeTeams),[activeTeams]);
  const teamNames = useMemo(() => (
    activeTeams.map(team => ({
      value:team.id,
      text:team.name,
    }))
  ),[activeTeams]);
  const cols = useMemo(() => [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter:sortByString('name'),
        showSorterTooltip:false,
        sortDirections:['descend','ascend'],
      },
      {
        title: 'Position',
        dataIndex: 'position',
        key: 'position',
        width:125,
        filters:positionNames.map(({ name }) => ({
          text:name,
          value:name,
        })),
        onFilter: (position, user) => user.position === position,
        filterDropdown: TableFilterDropdown,
        sorter:sortByString('position'),
        showSorterTooltip:false,
        sortDirections:['descend','ascend'],
      },
      {
        title: 'Teams',
        dataIndex: 'teams',
        key: 'teams',
        width:220,
        render:(_,user) => {
          const {
            [user.id]: ourUsersTeams = [],
          } = userTeams;
          return (
            ourUsersTeams
            .filter((teamId) => teamId in teamMap)
            .map((teamId) => (
              <OntraccrTag
                key={teamId}
                style={{
                  overflow:'hidden',
                  textOverflow:'ellipsis'
                }}
              >{teamMap[teamId].name}</OntraccrTag>
            ))
          );
        },
        filters:teamNames,
        onFilter: (teamId, user) => user.id in userTeams && userTeams[user.id].includes(teamId),
        filterDropdown: TableFilterDropdown,
      },
      ...additionalColumns,
    ],[positionNames,teamNames,teamMap,userTeams,additionalColumns,]);

  useEffect(() => {
    if(dispatch) dispatch(getUserTeams())
  },[dispatch]);

  const onHeaderRow = useCallback(() => {
    if (!company?.settings?.uxRedesignPt1) return null;
    return {
      className: 'ontraccr-table-header',
    };
  }, [company]);

  return (
    <div className='file-list-container' style={{ marginTop: 15 }}>
      <Table
        size='small'
        pagination={false}
        columns={cols}
        dataSource={ourUsers}
        style={{ width:'100%', height:'90%' }}
        scroll={scroll}
        rowSelection={{
          fixed:true,
          onChange:(...args) => onSelect(args),
          selectedRowKeys: selected[0],
          getCheckboxProps:(record) => ({
            disabled: company && company.userId === record.id || disableAll, // Cant remove owner from perms
            className: company?.settings?.uxRedesignPt1 ? 'ontraccr-checkbox' : '',
          }),
          preserveSelectedRowKeys: true
        }}
        rowKey='id'
        onHeaderRow={onHeaderRow}
      />
    </div>
  );
}
